import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const createGsapCore = () => {
    const timelines: { [key: string]: gsap.core.Timeline } = {};

    const createTimeline = (id: string, config?: gsap.TimelineVars) => {

        if ((timelines[id])) { // Remove incorrect await
            console.warn(`Timeline with id "${id}" already exists.`);
            return timelines[id];
        }
        const newTimeline = gsap.timeline({
            ...config,
            paused: true,
        });
        timelines[id] = newTimeline;
        return newTimeline;
    };

    const getTimeline = (id: string):gsap.core.Timeline | null => {
        // Check if the key exists in the timelines object

        return timelines[id];
    };


    const playTimeline = async (id: string) => {
        const timeline = await getTimeline(id);
        if (timeline) {
            timeline.play();
        }
    };

    const pauseTimeline = async (id: string) => {
        const timeline = await getTimeline(id);
        if (timeline) {
            timeline.pause();
        }
    };

    const killTimeline = async (id: string) => {
        const timeline = await getTimeline(id);
        if (timeline) {
            timeline.kill();
            delete timelines[id];
        }
    };

    const addScrollTrigger = async (
        timelineId: string,
        trigger: string | Element,
        config?: ScrollTrigger.Vars
    ) => {
        const timeline =  getTimeline(timelineId);
        if (timeline) {
            ScrollTrigger.create({
                trigger: trigger,
                animation: timeline as gsap.core.Animation,
                ...config,
            });
        } else {
            console.warn(
                `Timeline with id "${timelineId}" not found. Cannot add ScrollTrigger.`
            );
        }
    };

    return {
        createTimeline,
        getTimeline,
        playTimeline,
        pauseTimeline,
        killTimeline,
        addScrollTrigger,
    };
};
